<template>
  <div></div>
</template>

<script>
import {mapGetters} from "vuex";
import {clone} from 'lodash';
import {Notification} from "@/utils";

export default {
  name: 'RoomNotification',
  props: {
    isOpenExtendMenu: { type: Boolean, default: false },
  },
  computed: {
    ...mapGetters('user', [
      'me',
      'getUsername',
    ]),
    ...mapGetters('chat',[
      'chatNotification',
      'systemMessage'
    ]),
  },
  data() {
    return {
      loadedRoom: false,
    }
  },
  created() {
    this._Events = clone(_Events);
    this.$roomApi.addEventListeners(this._Events, this);
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
  },
  methods: {
    async initNotification() {
      try {
        await Notification.init();
      } catch (e) {
        console.error(e);
      } finally {
        this.loadedRoom = true;
      }
    },
    showNotification(message, options = {}) {
      try {
        if (!this.loadedRoom) {
          return;
        }
        message = message.escapeXml();

        Notification.show(message, options);

        if (this.isOpenExtendMenu) {
          return;
        }

        const showSnackbar = (message, options, target = 'default') => {
          this.$snackbar(snackbarTemplate(message, options)[target], {
            position: 'bottom-right',
            hideIcon: true,
            actions: options.actions,
          });
        }

        if (options.actions) {
          options.actions?.forEach(action => showSnackbar(message, options, action.target))
          return;
        }
        showSnackbar(message, options);
      } catch (e) {
        console.error(e);
      }
    },
  }
}

const _Events = {
  room_chat_text (e) {
    if (this.chatNotification) {
      this.showNotification(e.data.text, {
        title: this.$t('notification.notice.title', { '0' : this.getUsername(e.userId) }),
        actions: [
          {
            target: '.viewChat',
            handler: 'click',
            func: () => {
              this.$emit('openExtendMenu');
            },
            afterHide: true
          }
        ]
      })
    }
  },
  room_user_enter (e) {
    const { userId, nickname, username } = e.data.roomUser;
    if (this.me.userId === userId) {
      return;
    }

    if (this.chatNotification && this.systemMessage) {
      this.showNotification(this.$t('notification.notice.user.enter', { '0' : nickname || username }))
    }
  },
  room_user_leave (e) {
    const { nickname, username } = e.data.roomUser;

    if (this.chatNotification && this.systemMessage) {
      this.showNotification(this.$t('notification.notice.user.leave', { '0' : nickname || username }))
    }
  },
  room_data_init (e) {
    this.initNotification();
  },
}

const snackbarTemplate = (message, options) => ({
  '.viewChat':
    `<div class="w-full mr-2 space-y-1">
       <div class="flex gap-2">
         <p class="w-max rounded py-0.5 px-1 bg-blue-700 text-xs text-white">${options.title || this.$t('notification.snackbar.defaultTitle')}</p>
         <button class="viewChat w-max h-max rounded py-0.5 px-2 bg-green-700 text-xs text-white">${this.$t('notification.snackbar.buttonText')}</button>
       </div>
       <p class="w-max max-w-fit whitespace-normal break-all">${message}</p>
     </div>`,
  'default':
    `<div class="w-full mr-2">
       <p class="w-max rounded py-0.5 px-1 bg-blue-700 text-xs text-white">${options.title || this.$t('notification.snackbar.defaultTitle')}</p>
       <p class="message mt-1 w-max max-w-fit whitespace-normal break-all">${message}</p>
     </div>`
})

</script>